import { formatDistanceToNow, format, parseISO } from 'date-fns'
import { format as formatNumerable } from 'numerable'
import type { NumerableFormatNumberOptions } from 'numerable/formatter/types/format-number-options'

export function formatDate(value?: string | Date | null, f?: string): string {
  if (!value) return ''
  if (!f) f = 'PPpp'

  const dt = typeof value === 'string' ? parseISO(value) : value
  return format(dt, f)
}

export function formatDateAgo(value?: null | string | Date): string {
  if (!value) return ''

  const dt = typeof value === 'string' ? parseISO(value) : value
  return formatDistanceToNow(dt, { addSuffix: true })
}

export function formatNumber(
  value?: string | number | null,
  f?: string,
  options?: NumerableFormatNumberOptions
): string {
  if (!value) value = 0
  if (!f) f = '0,0'
  return formatNumerable(value, f, options)
}

export function formatCurrency(value?: string | number | null) {
  return formatNumber(value, '$0,0.00', { currency: 'USD' })
}

export function formatFileSize(bytes?: number | null): string {
  if (bytes === null || bytes === undefined) return 'ND'
  if (bytes === 0) return '0 B'
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    sizes.length - 1
  )
  const value = bytes / Math.pow(1024, i)
  return `${value.toFixed(2)} ${sizes[i]}`
}

export function parseStringISO(value?: string | null) {
  if (!value) return
  return parseISO(value)
}
